import * as React from "react";

import logo from "./dbars_logo_payoff.svg"
const LogoBlackSvg = (props) => (
    <img src={logo} width={180} />
);
export default LogoBlackSvg;
